import React from 'react';
import LazyloadingSelect from '../../components/LazyloadingSelect/LazyloadingSelect';
import * as SERVICE from '../../constants/service.types';
import { useTranslation } from 'react-i18next';
import { Dropdown, Menu, Popover, Tooltip } from 'antd';
import { DeleteOutlined, EditOutlined, MenuOutlined, PlusOutlined, } from '@ant-design/icons';
import CameraTree from '../Live/CameraTree';
import { MODE_CAMERA, MODE_LIVE } from '../../constants';

const CameraSearch = ({
  // prop camera
  value,
  onChangeSelect,
  refreshCameraGroupSelect = null,
  labelDefault = 'All camera',
  onChangeCreate,
  onChangeEdit,
  onChangeDelete,
  checkData,
  // mode = 'live' or 'camera'
  mode = MODE_CAMERA,
  // prop live
  checkGroup,
  getDeviceByPage,
  pinnedCamera,
  onUpdatePinCamera,
  visibleTree,
  setVisibleTree,
}) => {
  const { t } = useTranslation();

  const menu = (
    <Menu>
      {checkData === 0 && (
        <Menu.Item key="0" onClick={() => onChangeCreate()}>
          <span>
            <PlusOutlined />
            {t('Create Group')}
          </span>
        </Menu.Item>
      )}
      {checkData !== 0 && (
        <Menu.Item key="1" onClick={() => onChangeEdit()}>
          <span>
            <EditOutlined />
            {t('Update Group')}
          </span>
        </Menu.Item>
      )}
      {checkData !== 0 && (
        <Menu.Item key="2" onClick={() => onChangeDelete()}>
          <span>
            <DeleteOutlined />
            {t('Delete Group')}
          </span>
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <div
      className="search-camera"
      style={{ marginBottom: '8px', display: 'flex' }}
    >
      <LazyloadingSelect
        // key để tạo lại LazyloadingSelect khi thay đổi labelDefault
        key={labelDefault}
        size={10}
        value={
          value
            ? { label: value.name, value: value.id }
            : { label: t(labelDefault), value: 0 }
        }
        onChange={onChangeSelect}
        defaultOption={{ label: t(labelDefault), value: 0 }}
        serviceId={SERVICE.LIST_DEVICE_GROUP_BY_PAGE_V2}
        searchField="name"
        reduxVariableName="listDeviceGroupByPage"
        convertOptionData={(listDeviceGroupByPage) =>
          listDeviceGroupByPage.deviceGroups?.map((item) => ({
            ...item,
            value: item.id,
            label: item.name,
          }))
        }
        refreshKey={refreshCameraGroupSelect}
        selectProps={{
          style: { width: '89%', marginRight: '7px', marginTop: '12px' },
        }}
      />

      {mode === MODE_CAMERA && (
        <Dropdown overlay={menu} trigger={['click']}>
          <MenuOutlined style={{ fontSize: 20, marginTop: '17px' }} />
        </Dropdown>
      )}
      {mode === MODE_LIVE && checkGroup === 0 && (
        <Popover
          placement="bottomLeft"
          content={
            <CameraTree
              getDeviceByPage={getDeviceByPage}
              pinned={pinnedCamera}
              onUpdatePinCamera={onUpdatePinCamera}
            />
          }
          trigger="click"
          visible={visibleTree}
          onVisibleChange={(visible) => setVisibleTree(visible)}
        >
          <Tooltip placement="bottomLeft" title={t('Camera list')}>
            <div className="view-tree">
              <MenuOutlined
                style={{
                  fontSize: 20,
                  marginTop: '17px',
                }}
              />
            </div>
          </Tooltip>
        </Popover>
      )}
    </div>
  );
};

export default CameraSearch;
